
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';

import { CampaignsActions } from '@actions/index'
import * as fromCampaigns from '@reducers/index'
import { Observable } from 'rxjs';
import { ReviewRequestCampaignModel, RequestModel, SmsModel, BasicReviewRequestCampaignInfo } from '@models/index';
import { EmailModel } from '@models/email.model';
import { map } from 'rxjs/operators';
import { sortCampaign } from '@utilities/function-utils';

@Injectable({
    providedIn: 'root'
})
export class CampaignsFacadeService {

    constructor(private store: Store<any>, public router: Router,) { }

    getReviewRequestCampaigns$(): Observable<ReviewRequestCampaignModel[]> {
        return this.store.select(fromCampaigns.getReviewRequestCampaigns)
            .pipe(
                map(items => items.sort(sortCampaign))
            )
    }

    getSelectedReviewRequestCampaign$(): Observable<ReviewRequestCampaignModel> {
        return this.store.select(fromCampaigns.getSelectedReviewRequestCampaign)
    }

    getSaveSuccessCampaign$(): Observable<boolean> {
        return this.store.select(fromCampaigns.getSaveSuccessCampaign)
    }

    getAddSuccessCampaign$(): Observable<boolean> {
        return this.store.select(fromCampaigns.getAddSuccessCampaign)
    }

    getCampaignsError$(): Observable<string> {
        return this.store.select(fromCampaigns.getErrorCampaign)
    }

    searchReviewRequestCampaigns() {
        const request: RequestModel = {
            params: `reviewRequestCampaign`,
        }
        this.store.dispatch(CampaignsActions.searchReviewRequestCampaigns({ request }))
    }

    searchReviewRequestCampaignsByLocationId(locationId: string) {
        const request: RequestModel = {
            params: `reviewRequestCampaign?locationId=${locationId}`,
        }
        this.store.dispatch(CampaignsActions.searchReviewRequestCampaignsByLocationId({ request }))
    }

    searchReviewRequestCampaign(campaignId: string) {
        const request: RequestModel = {
            params: `reviewRequestCampaign/campaign?campaignId=${campaignId}`
        }
        this.store.dispatch(CampaignsActions.searchReviewRequestCampaign({ request }))
    }

    saveReviewRequestCampaign(reviewRequestCampaign: ReviewRequestCampaignModel) {
        const request: RequestModel = {
            params: `reviewRequestCampaign`,
            payload: reviewRequestCampaign
        }
        this.store.dispatch(CampaignsActions.saveReviewRequestCampaign({ request }))
    }
    deleteCampaign(campaignId: string) {
        const request: RequestModel = {
            params: `reviewRequestCampaign/${campaignId}`
        }
        this.store.dispatch(CampaignsActions.deleteCampaign({ request }));
    }
    setCampaignState(campaignId: string, campaignState: string, editionState: string) {
        const request: RequestModel = {
            params: `reviewRequestCampaign/state`,
            payload: { campaignId: campaignId, state: campaignState, editionState: editionState }
        }
        this.store.dispatch(CampaignsActions.setCampaignState({ request }))
    }
    setSelectedReviewRequestCampaign(reviewRequestCampaign: ReviewRequestCampaignModel) {
        this.store.dispatch(CampaignsActions.setSelectedReviewRequestCampaign({ reviewRequestCampaign }))
    }
    setSaveSuccesCampaign(save: boolean) {
        this.store.dispatch(CampaignsActions.setSaveSuccesCampaign({ save }))
    }
    sendSmsTest(phoneNumber: number, smsContent: SmsModel) {
        const request: RequestModel = {
            params: 'messaging/sendSms',
            payload: {
                phoneNumber,
                message: smsContent.smsBody
            }
        }
        this.store.dispatch(CampaignsActions.sendSmsContentTest({ request }))
    }

    sendEmailTest(email: EmailModel, emailTest: string, campaignId: string, businessImage: string) {
        const request: RequestModel = {
            params: `messaging/sendEmailWithHtml`,
            payload: {
                from: "noreply@getmorereviews.com",
                subject: email.subject,
                to: emailTest,
                header: email.header,
                content: email.wysiwyg,
                imageUrl: businessImage,
                campaignId: campaignId
            }
        }
        this.store.dispatch(CampaignsActions.sendEmailTest({ request }))
    }

    getLocationCampaignsBasicInfoByLocationId(locationId: string) {
        const request: RequestModel = {
            params: `reviewRequestCampaign/basic-info?locationId=${locationId}`,
        }
        this.store.dispatch(CampaignsActions.getLocationCampaignsBasicInfoByLocationId({ request }))
    }

    getLocationCampaignsBasicInfo() {
        const request: RequestModel = {
            params: `reviewRequestCampaign/basic-info`,
        }
        this.store.dispatch(CampaignsActions.getLocationCampaignsBasicInfo({ request }))
    }

    getLocationCampaignsBasicInfo$(): Observable<BasicReviewRequestCampaignInfo[]> {
        return this.store.select(fromCampaigns.BasicReviewRequestCampaignInfo)
    }

    getcampaignsBasicInfoReports$(): Observable<BasicReviewRequestCampaignInfo[]> {
        return this.store.select(fromCampaigns.getcampaignsBasicInfoReports)
    }

    addCampaign(campaignName: string) {
        const request: RequestModel = {
            params: `reviewRequestCampaign/add`,
            payload: {
                name: campaignName
            }
        }
        this.store.dispatch(CampaignsActions.addCampaign({ request }))
    }

    setSelectedCampaign(campaign: ReviewRequestCampaignModel) {
        this.store.dispatch(CampaignsActions.setSelectedCampaign({ campaign }))
    }

    filterCampaign(payload: { page: number, size: number, query: string }) {
        const request: RequestModel = {
            params: `reviewRequestCampaign/filter?page=${payload.page}&size=${payload.size}&query=${payload.query}`
        }
        this.store.dispatch(CampaignsActions.filterCampaign({ request }))
    }

    changeLocationPreferredCampaign(campaignId: string) {
        const request: RequestModel = {
            params: `reviewRequestCampaign/change-preferredCampaign`,
            payload: { campaignId }
        }
        this.store.dispatch(CampaignsActions.changeLocationPreferredCampaign({ request }))
    }
    isChangePreferredCampaig$(): Observable<boolean> {
        return this.store.select(fromCampaigns.isChangePreferredCampaig)
    }
    getLocationCampaignsBasicInfoByLocationIdReport(locationId: string) {
        const request: RequestModel = {
            params: `reviewRequestCampaign/basic-info?locationId=${locationId}`,
        }
        this.store.dispatch(CampaignsActions.getLocationCampaignsBasicInfoReports({ request }))
    }

    setAddCampaign(status: boolean) {
        this.store.dispatch(CampaignsActions.setAddCampaign({ status }))
    }
}
